import axios from 'axios';
const URL_API_REGISTRO = process.env.VUE_APP_URL_API_REGISTRO;

export class RegistroApiService {
  
  getRegistroById(regId) {
    let config = {
      headers: { 'Authorization': localStorage.getItem('token'), 'instalacion' : localStorage.getItem("instalacion") }
    }
    const url = `${URL_API_REGISTRO}${regId}`
    return axios
      .get(url, config)
      .then(function (response) {
        return response.data
      })
      .catch(function (error) {
        if (error.response.status === 401 || error.response.status === 403) {
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error
      })  
  }
  addRegistro(registro) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_REGISTRO}`;
    return axios
      .post(url, registro, config)
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  updateRegistro(registro) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_REGISTRO}`;
    return axios
      .put(url, registro, config)
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

}